<template>
  <div class="card" :class="{dummy: isDummy}">
    <router-link class="alp" :to="getLink(data.link)" v-if="loaded && !isDummy">
      <div class="thumb"><img :src="data.img" :alt="data.title"></div>
      <div class="desc">
        <p class="ttl txt-overflow" ref="tit" v-html="data.title"></p>
        <p class="txt txt-overflow" ref="desc" v-html="data.theme"></p>
        <div class="info" v-if="type === 'concour'"><span class="data1">締切：{{ data.limit.limit_date | moment}}</span><span class="data2">{{(data.limit.limit_type === 'なし') ? '' : data.limit.limit_type}}</span></div>
        <div class="info" v-else-if="type === 'teaching'"><span class="data1">{{ category(data.category) }}</span><span class="data2">{{ tag(data.age) }}</span></div>
        <div class="info" v-else-if="type === 'event'"><span class="data1">開催月：{{ category(data.date) }}</span><span class="data2">エリア：{{ tag(data.area) }}</span></div>
      </div>
    </router-link>
    <transition name="fade">
      <div class="cov" v-show="!loaded"><div class="spin"></div></div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
$fontcolor: #333;

.dummy {
  visibility: hidden;
}

.cov {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #efefef;
  .spin {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
  }
}

.card {
  position: relative;
  margin-top: 2.5%;
  width: 31.633%;
  background: #fff;
  &:nth-of-type(3n) {
    margin-right: 0;
  }
  a {
    display: block;
  }
  img {
    width: 100%;
  }
  .desc {
    padding: 25px 20px 0;
    overflow: hidden;
    background: #fff;
    .ttl {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.8;
      color: $fontcolor;
      height: 3.6em;
    }
    .txt {
      margin: 20px 0;
      font-size: 12px;
      font-weight: bold;
      line-height: 1.8;
      color: $fontcolor;
      height: 3.6em;
      box-sizing: content-box;
    }
    .info {
      border-top: 1px solid #ddd;
      padding: 16px 0;
      line-height: 1;
      font-size: 10px;
      font-weight: 500;
      color: $fontcolor;
      span.data2 {
        float: right;
      }
    }
  }
  @media only screen and (max-width: 750px) {
    margin-top: 6% !important;
    width: 100%;
  }
}
</style>

<script>
// import Spin from "spin";
import moment from "moment";
import _ from "lodash";
import $ from "jquery";
import ComponentUtils from "../../utils/ComponentUtils.js";
import imagesLoaded from "imagesloaded";
moment.locale("ja");
export default {
  name: "card",
  props: ["type", "data", "tab", "currentTab", "isDummy", "commonData"],
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    if (this.isDummy) {
      return;
    }
    this.$nextTick(() => {
      imagesLoaded(this.$el, {}, this.imageLoadedDone);
    });
    // var opts = {
    //   lines: 7, // The number of lines to draw
    //   length: 11, // The length of each line
    //   width: 5, // The line thickness
    //   radius: 8, // The radius of the inner circle
    //   scale: 1, // Scales overall size of the spinner
    //   corners: 1, // Corner roundness (0..1)
    //   color: "#999999", // CSS color or array of colors
    //   fadeColor: "transparent", // CSS color or array of colors
    //   speed: 1.3, // Rounds per second
    //   rotate: 0, // The rotation offset
    //   animation: "spinner-line-fade-quick", // The CSS animation name for the lines
    //   direction: 1, // 1: clockwise, -1: counterclockwise
    //   zIndex: 2e9, // The z-index (defaults to 2000000000)
    //   className: "spinner", // The CSS class to assign to the spinner
    //   top: "50%", // Top position relative to parent
    //   left: "50%", // Left position relative to parent
    //   position: "absolute" // Element positioning
    // };
    // new Spin(opts).spin(
    //   $(this.$el)
    //     .find(".cov")
    //     .find(".spin")[0]
    // );
  },
  filters: {
    moment: function(date) {
      return moment(date).format("YYYY年M月D日（ddd）");
    }
  },
  computed: {
    tags() {
      if (!this.commonData || !this.commonData.length) {
        return [];
      }
      return this.commonData[0] || [];
    },
    categories() {
      if (!this.commonData || !this.commonData.length) {
        return [];
      }
      return this.commonData[1] || [];
    }
  },
  methods: _.assign(
    {
      getLink(link) {
        const lnk = this.parseURL(link);
        return lnk.pathname;
      },
      category(id) {
        let res = "";
        const cats = _.clone(this.categories);
        _.some(cats, category => {
          if (category.term_id == id) {
            res = category.name;
            return false;
          }
        });
        return res;
      },
      tag(ids) {
        let res = "";
        const reses = [];
        _.each(ids, id => {
          _.some(this.tags, tag => {
            if (tag.term_id == id) {
              reses.push(tag.name);
              return false;
            }
          });
        });
        res = reses[0];
        if (reses.length >= 2) {
          res += " ...";
        }
        return res;
      },
      imageLoadedDone() {
        this.txtOverflows();
        this.$nextTick(() => {
          this.txtOverflows();
          this.loaded = true;
          setTimeout(() => {
            this.txtOverflows();
          }, 10);
          setTimeout(() => {
            this.txtOverflows();
          }, 1100);
          setTimeout(() => {
            this.txtOverflows();
          }, 4000);
          setTimeout(() => {
            this.txtOverflows();
          }, 8000);
          $(window).resize(this.txtOverflows);
        });
      },
      txtOverflows() {
        this.txtOverflow($(this.$refs.tit));
        this.txtOverflow($(this.$refs.desc));
      }
    },
    ComponentUtils
  )
};
</script>
